import PropTypes from 'prop-types';
import React from 'react';

const AnswerStrategy = ({question: {description}, children}) => (
    <div>
        <b className="smart-question-description">{description}</b>
        <div className="text-center">{children}</div>
    </div>
);

AnswerStrategy.propTypes = {
    question: PropTypes.shape({
        description: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.element
};

export default AnswerStrategy;



// WEBPACK FOOTER //
// ./components/smart_question/answer_strategy.js